module.exports = __webpack_public_path__ + "static/media/home.46fb9fae.svg";